import mainImage from '../../../../../assets/images/base/main-first-page-1.png';
import styles from './MainImage.module.css';

export const MainImage = () => (
  <div className={styles.MainImage}>
    <img alt="main-landing" src={mainImage} />
  </div>
);
